import { render } from "./Room.vue?vue&type=template&id=0065aa30"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
script.render = render

export default script